import script from "./TeacherTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeacherTabs.vue?vue&type=script&setup=true&lang=ts"

import "./TeacherTabs.vue?vue&type=style&index=0&id=b159118e&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b159118e"]])

export default __exports__